export default class InvalidGradientRowIndex extends Error {}
